module.exports = __webpack_public_path__ + "img/about_leave.a41b478e.jpg";